import { cnBase } from 'tailwind-variants';

const MemoryCard = ({
  children,
  className,
  style,
}: {
  children: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
}) => {
  return (
    <div
      style={{
        // background:
        //   'linear-gradient(103.65deg, #FFFFFF -2.08%, #F0F3F7 96.86%)',
        boxShadow: '0px 4px 40px 0px #00000040',
        borderRadius: '16px',
        ...style,
      }}
      className={cnBase('bg-mono-color-white', className)}
    >
      {children}
    </div>
  );
};

export default MemoryCard;
